import styled from 'styled-components';
import { Box } from '@mui/material';
import { DetailsCard } from 'elements/DetailsCard';
import { maskDemoField } from 'utils/demoMask';
import { formatClaimDetailCurrency } from 'utils/formatClaimDetailCurrency';
import { hasClaimDetailValue } from 'utils/hasClaimDetailValue';

export const DetailCard = ({ application, isDemo }) => {
  const tiles = [
    {
      title: 'Account Name',
      value: maskDemoField(isDemo, 'account-name', application.account_name),
    },
    {
      title: 'Address',
      value: maskDemoField(isDemo, 'address', application.apartment_building_address),
    },
    { title: 'Application Type', value: application.app_type },
    { title: 'Bond Issue Date', value: application.bond_issue_date },
    { title: 'Claim Status', value: application.claim_status },
    { title: 'Claim File Status', value: application.claim_file_status },
    {
      title: 'Created Date',
      value: application.sf_createdDate ? application.sf_createdDate.split('T')[0] : null,
    },
    {
      title: 'Operator Name',
      value: maskDemoField(isDemo, 'landlord-name', application.landlord_name),
    },
    { title: 'Lease Start Date', value: application.lease_start_date },
    { title: 'Lease End Date', value: application.lease_end_date },
    { title: 'Denial Reason', value: application.denial_reason_1 },
    { title: 'Monthly Rent', value: formatClaimDetailCurrency(application.monthly_rent) },
    { title: 'Deductible', value: formatClaimDetailCurrency(application.deductible) },
  ].filter((tile) => hasClaimDetailValue(tile.value));

  return (
    <Box display="flex" flexDirection="column" gap="10px">
      <Box display="flex" flexDirection="column" gap="8px">
        <LowContainer>
          {tiles.map((tile) => (
            <DetailsCard key={tile.title} title={tile.title} value={tile.value} />
          ))}
        </LowContainer>
      </Box>
    </Box>
  );
};

const LowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  & > div {
    width: 100%;
  }
  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
